import WithdrawComponent from '@components/withdraw';
import * as React from 'react';

export interface IWithDrawProps {}

export default function WithDraw(props: IWithDrawProps) {
  return <WithdrawComponent />;
}
